import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    select: {
        '& > select': {
            padding: '10px',
        },
        color: '#4b4b4b',
        backgroundColor: (props) => props?.backgroundWhiteCustom,
    },
    backgroundCustom: {
        backgroundColor: (props) => props?.customColorSelect && `${props?.customColorSelect} !important`,
    },
    formControl: {
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
}));

const SelectorInput = (props) => {
    const classes = useStyles(props);
    const {
        valueSelected, optionList, onChange, error, helperText, sortType, variant, errorTable, isCustomColor,
    } = props;
    const [valueOption, setValueOption] = useState(valueSelected);

    useEffect(() => {
        setValueOption(valueSelected);
    }, [valueSelected, errorTable]);

    const handleChangeValue = (e) => {
        setValueOption(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    };

    const sortByValue = (keys, sortType) => {
        if (sortType === 'asc') {
            keys.sort();
        } else if (sortType === 'desc') {
            keys.sort().reverse();
        }

        return keys;
    };

    return (
        <FormControl variant={variant} className={isCustomColor && classes.formControl} fullWidth error={error}>
            <Select
                className={classes.select}
                native
                value={valueOption}
                onChange={(option) => handleChangeValue(option)}
            >
                {sortByValue(Object.keys(optionList), sortType).map((key) => (
                    <option value={key} key={key} className={classes.backgroundCustom}>{optionList[key]}</option>
                ))}
            </Select>
            <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
    );
};
SelectorInput.defaultProps = {
    error: false,
    helperText: '',
    valueSelected: '',
    sortType: '',
    variant: 'outlined',
    errorTable: false,
    isCustomColor: false,
};

SelectorInput.propTypes = {
    optionList: PropTypes.objectOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    valueSelected: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    sortType: PropTypes.oneOf(['asc, desc', '']),
    variant: PropTypes.string,
    errorTable: PropTypes.bool,
    isCustomColor: PropTypes.bool,
};

export default SelectorInput;
